import axios from "axios";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import InterestPost from "./InterestPost";
import { GET_LINKFEATURE_API } from "../../../Adsy/services/api";
import AdminZustandStore from "../../AdminZustandStore";
import { extractDomain } from "../../../helperJs/helper";
import "../../../Adsy/css/site.css";
import Button from "@semcore/button";

import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { Checkbox } from "@mui/material";
import FallbackLoader from "../../../Mycomponent/share/components/FallbackLoader";
import PostBuyLinkType from "./PostBuyLinkType";
import Input from "@semcore/ui/input";
import SearchM from "@semcore/ui/icon/Search/m";
import DropdownMenu from "../../../common/components/dropdown";

const GuestPost = () => {
  const tabMenus = ["Backlinks", "Interest Shown"];
  const [selectedTab, setSelectedTab] = useState(1);
  const [SelectedDomain, setSelectedDomain] = useState([]);
  const [visible, setVisible] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [linkType, setLinkType] = useState("");
  const [debouncedValue, setDebouncedValue] = useState("");
  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 100,
    pageLoader: false,
    rowsPerPageOptions: [100],
  });
  const { guestPost } = AdminZustandStore((state) => state);

  const getLinkFeature = async () => {
    AdminZustandStore.setState({
      guestPost: {
        data: [],
        loading: true,
        error: false,
      },
    });
    try {
      const resp = await axios.get(GET_LINKFEATURE_API());
      AdminZustandStore.setState({
        guestPost: {
          data: resp.data,
          loading: false,
          error: false,
        },
      });
    } catch (error) {
      AdminZustandStore.setState({
        guestPost: {
          data: [],
          loading: false,
          error: "Server Error",
        },
      });
    }
  };

  useEffect(() => {
    getLinkFeature();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => setSearchText(debouncedValue), 500);
    return () => clearTimeout(handler);
  }, [debouncedValue]);

  const handleTabOption = (value) => setSelectedTab(value);

  const tableHeader = useMemo(() => {
    return [
      {
        label: "DOMAIN",
        key: "domain",
        minWidth: 100,
        align: "left",
        width: "25%",
      },
      {
        label: "TRAFFIC",
        key: "Traffic",
        minWidth: 120,
        width: "25%",
        align: "left",
      },
      {
        label: "COST",
        key: "Cost",
        minWidth: 100,
        align: "center",
        width: "25%",
      },
      {
        label: "BUY STATUS",
        key: "Buy",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
      {
        label: "DR",
        key: "DR",
        minWidth: 100,
        align: "center",
        width: "25%",
      },
      {
        label: "DA",
        key: "DA",
        minWidth: 100,
        align: "center",
        width: "25%",
      },
      // {
      //   label: "CATEGORIES",
      //   key: "Niche",
      //   minWidth: 120,
      //   align: "center",
      //   width: "25%",
      // },
      {
        label: "STATUS",
        key: "Status",
        minWidth: 120,
        align: "center",
        width: "25%",
      },
    ];
  }, []);

  const searchData = useMemo(() => {
    if (guestPost.data?.length === 0) return [];
    let filtered = guestPost.data;
    if (linkType && linkType !== "None") {
      filtered = filtered?.filter((item) => {
        if (linkType === "Buy Now") return item.Buy === "buynow";
        if (linkType === "Enquire Now") return item.Buy === "Enquiry";
        return true;
      });
    }
    if (searchText) {
      const normalize = (val) => val?.toLowerCase();
      filtered = filtered?.filter((item) => {
        const domain_url = extractDomain(item.URL);
        const domain = normalize(domain_url);
        const categories_list = item?.Niche
          ? item.Niche.split(/[,/]/)
              .map((c) => c.trim())
              .filter(Boolean)
          : [];
        const categories = categories_list?.map((cat) => normalize(cat)) || [];
        const domainMatch = domain?.includes(normalize(searchText));
        const categoryMatch = categories.some((category) =>
          category.includes(normalize(searchText))
        );
        return domainMatch || categoryMatch;
      });
    }
    return filtered;
  }, [guestPost, searchText, linkType]);

  const paginatedData = useMemo(() => {
    if (searchData?.length === 0) return [];
    const { page, rowsPerPage } = pagination;
    return searchData?.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [searchData, pagination]);

  const rows = useMemo(() => {
    if (!paginatedData || paginatedData?.length === 0) return [];
    return paginatedData?.map((item, index) => {
      return {
        ...item,
        id: `#${index + 1}`,
        Buy: item.Buy === "buynow" ? "Buy Now" : "Enquiry",
        domain: extractDomain(item.URL),
        DR: Number(item.DR) || 0,
        Traffic: Number(item.Traffic) || 0,
        DA: Number(item.DA) || 0,
        CF: 0,
        TF: 0,
        SS: 0,
        Cost: Number(item.Cost) || 0,
        Status: item.Status,
        Niche: item?.Niche
          ? item.Niche.split(/[,/]/)
              .map((c) => c.trim())
              .filter(Boolean)
          : [],
      };
    });
  }, [paginatedData]);

  const handleSelectAllKeyword = () => {
    if (SelectedDomain?.length === rows?.length) {
      setSelectedDomain([]);
    } else {
      setSelectedDomain(rows);
    }
  };

  const handleSelectedKeyword = (obj) => {
    setSelectedDomain((prev) => {
      const isPresent = prev?.find((item) => item.domain === obj.domain);
      if (isPresent) {
        return prev.filter((item) => item.domain !== obj.domain);
      } else {
        return [...prev, obj];
      }
    });
  };

  const handleIsKeywordSelected = (domain) => {
    const isPresent = SelectedDomain?.find((item) => item.domain === domain);
    return Boolean(isPresent);
  };

  const handleLoadingState = () => {
    setTimeout(() => {
      setPagination((prev) => ({
        ...prev,
        pageLoader: false,
      }));
    }, 300);
  };

  const handleChangeRowsPerPage = (event) => {
    setPagination((prev) => ({
      ...prev,
      page: 0,
      rowsPerPage: +event.target.value,
      pageLoader: true,
    }));
    setSelectedDomain([]);
    handleLoadingState();
  };

  const handleChangePage = (event, newPage) => {
    if (pagination.pageLoader) return;
    setPagination((prev) => ({
      ...prev,
      page: newPage,
      pageLoader: true,
    }));
    setSelectedDomain([]);
    handleLoadingState();
  };

  const LinkTypeArr = useMemo(() => {
    return {
      value: linkType || "Select Buying Status",
      placeholder: "Select Buying Status",
      disabled: false,
      data: ["None", "Buy Now", "Enquire Now"],
      height: "38px",
      loading: false,
    };
  }, [linkType]);

  const handleLinkTypeFilter = useCallback((category) => {
    setLinkType(category === "None" ? "" : category);
  }, []);

  return (
    <>
      {visible && (
        <PostBuyLinkType
          {...{
            visible,
            setVisible,
            SelectedDomain,
            setSelectedDomain,
          }}
        />
      )}
      <h1 className="page-title table_title mb-2">Buy Guest Posts</h1>
      <div className="w-100 d-flex align-items-center flex-wrap gap-3">
        <ul className="tab-bar-menu">
          {tabMenus.map((label, index) => (
            <li
              key={index}
              className={selectedTab === index + 1 ? "active" : ""}
            >
              <button
                className="tab-bar-menu-button heading-medium"
                onClick={() => handleTabOption(index + 1)}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
        {guestPost?.data?.length === 0 ? null : (
          <div className="ms-auto">
            Total Publishers: <b>{guestPost.data?.length || 0}</b>
          </div>
        )}
      </div>
      <section className="sites">
        {selectedTab === 1 ? (
          <>
            <div className="mt-2 d-flex align-items-center flex-wrap gap-3">
              <Input wMax={"300px"} w={"100%"} h={"38px"} ml={"auto"}>
                <Input.Value
                  placeholder="Search here"
                  autoComplete="off"
                  value={debouncedValue}
                  onChange={(value) => setDebouncedValue(value)}
                />
                <Input.Addon>
                  <SearchM />
                </Input.Addon>
              </Input>

              <div className="w-100" style={{ maxWidth: "200px" }}>
                <DropdownMenu
                  {...{
                    menuData: LinkTypeArr,
                    handleSelect: handleLinkTypeFilter,
                  }}
                />
              </div>

              <Button
                onClick={() => setVisible(true)}
                disabled={SelectedDomain?.length === 0}
                size="l"
                style={{ backgroundColor: "#365486", color: "#fff" }}
              >
                Update Post Link
              </Button>
            </div>
            <Paper
              sx={{
                backgroundColor: "background.paper",
                boxShadow: "none",
                "& .MuiTableContainer-root": {
                  boxShadow: "none",
                },
              }}
              className="my-2 keywords_table_CONTA vir-table-border"
            >
              <TableContainer sx={{ maxHeight: 700 }}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {tableHeader?.map((header) => (
                        <TableCell
                          variant="head"
                          key={header.label}
                          align={header.align}
                          sx={{
                            padding:
                              header.label === "DOMAIN"
                                ? "10px 5px"
                                : "10px 0px",
                            height: "55px",
                            fontSize: "0.8em",
                            fontWeight: "700",
                            textTransform: "uppercase",
                            minWidth: header?.minWidth,
                            backgroundColor: "rgba(220, 223, 228)",
                          }}
                        >
                          {header.label === "DOMAIN" && (
                            <Checkbox
                              readOnly
                              color="primary"
                              checked={
                                SelectedDomain?.length > 0 &&
                                SelectedDomain?.length === paginatedData?.length
                              }
                              onChange={handleSelectAllKeyword} // check this
                            />
                          )}

                          {header?.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pagination?.pageLoader || guestPost.loading ? (
                      <TableRow>
                        <TableCell colSpan={tableHeader?.length + 1}>
                          <FallbackLoader />
                        </TableCell>
                      </TableRow>
                    ) : rows?.length === 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={tableHeader?.length + 1}
                          className="text-center"
                        >
                          <b>NO Data!</b>
                        </TableCell>
                      </TableRow>
                    ) : (
                      rows?.map((res, index) => (
                        <TableRow
                          hover
                          key={`guestpost-${res.domain}-${index}`}
                        >
                          {tableHeader?.map((header) => {
                            const value = res?.[header.key];
                            return (
                              <TableCell
                                key={header.key}
                                align={header.align}
                                sx={{
                                  cursor: "default",
                                  padding:
                                    header.label === "DOMAIN"
                                      ? "10px 5px"
                                      : "10px 0px",
                                }}
                              >
                                {header.label === "DOMAIN" ? (
                                  <div className="d-flex align-items-enter">
                                    <Checkbox
                                      color="primary"
                                      checked={handleIsKeywordSelected(
                                        res.domain
                                      )}
                                      readOnly
                                      onChange={() =>
                                        handleSelectedKeyword(res)
                                      }
                                    />
                                    <span className="d-flex align-items-center">
                                      {value}
                                    </span>
                                  </div>
                                ) : header.label === "COST" ? (
                                  `$${value}`
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                sx={{
                  borderTop: "1px solid rgba(224, 224, 224, 1)",
                  cursor: "default",
                  "& .MuiTablePagination-actions": {
                    width: 90,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  },
                  "& .MuiTablePagination-displayedRows": {
                    padding: 0,
                    margin: 0,
                  },
                  "& .MuiTablePagination-selectLabel": {
                    padding: 0,
                    margin: 0,
                  },
                }}
                rowsPerPageOptions={pagination.rowsPerPageOptions}
                component="div"
                count={searchData?.length || 0}
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </>
        ) : selectedTab === 2 ? (
          <InterestPost />
        ) : (
          <h6>Exclude sites I've worked with</h6>
        )}
      </section>
    </>
  );
};

export default GuestPost;
